module.exports = __webpack_public_path__ + "img/logo-sidebar.49845fb2.png";